import { useQuery } from '@apollo/client';
import CHECKIN_TIMES from 'store/queries/CHECKIN_TIMES';

import moment from 'moment';

const subtractMinutes = ({ time, minutes }) => moment(time, 'HH:mm').subtract(minutes, 'minutes').format('HH:mm');

const getRecommendedStationArrivalTime = ({ departs, arrival }) => {
  if (arrival === null) return null;
  return subtractMinutes({
    time: departs,
    minutes: arrival
  });
};

const useCheckinTimesQuery = ({ reference, journey }) => {
  const { data, loading, error } = useQuery(CHECKIN_TIMES, {
    variables: { reference },
    fetchPolicy: 'network-only'
  });

  const checkinTimeRules = data?.checkinTimes?.flatMap(({ rules }) => rules?.map(({ tcn, arrivalTime }) => ({ tcn, arrivalTime })));
  const legCheckinTimeRules = checkinTimeRules?.find(({ tcn }) => journey.products.some(({ ticketNumber }) => ticketNumber === tcn));
  const recommendedStationArrivalTime = getRecommendedStationArrivalTime({
    departs: journey?.timing?.departs,
    arrival: legCheckinTimeRules?.arrivalTime
  });

  if (error || !data?.checkinTimes.length) {
    console.error(`useCheckinTimes ERROR: ${error?.message}`);
    return {
      recommendedStationArrivalTime: null,
      loading,
      error
    };
  }

  return {
    recommendedStationArrivalTime,
    loading,
    error
  };
};

export default useCheckinTimesQuery;
